var React = require('react');

function PlayIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.4022 18L15.799 21.8123L15.799 14.1876L22.4022 18Z","fill":"currentColor"}));
}

PlayIcon.defaultProps = {"width":"100%","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 36 36","fill":"none"};

module.exports = PlayIcon;

PlayIcon.default = PlayIcon;
